<ng-template #viewLeadingMenuBar>
  @let compact = hostComponent.compactMenuBar();
  <div class="flex items-center gap-2 h-full">
    <soft-ds-select
      size="md"
      [value]="hostComponent.calendarViewType()"
      (valueChange)="$event && hostComponent.calendarViewType.set($event)"
      leadingIcon="fa-regular fa-calendar-range"
      listboxTitle="Zeitraum"
      [minWidth]="compact ? null : '160px'"
      data-testid="garage-roster-view-type"
    >
      @for (opt of viewTypeOptions(); track opt.v) {
        <soft-ds-select-option [value]="opt.v" [label]="opt.l" />
      }
    </soft-ds-select>

    <soft-ds-select
      size="md"
      [value]="hostComponent.calendarColumnWidth()"
      (valueChange)="$event && hostComponent.calendarColumnWidth.set($event)"
      leadingIcon="fa-regular fa-arrows-left-right"
      listboxTitle="Spaltenbreite"
      [minWidth]="compact ? null : '140px'"
      data-testid="garage-roster-column-width"
    >
      <soft-ds-select-option value="small" label="Schmal" />
      <soft-ds-select-option value="large" label="Normal" />
      <soft-ds-select-option value="xxxlarge" label="Breit" />
    </soft-ds-select>

    <soft-ds-select
      size="md"
      [value]="hostComponent.calendarDetails()"
      (valueChange)="$event && hostComponent.calendarDetails.set($event)"
      leadingIcon="fa-regular fa-list"
      listboxTitle="Details"
      [minWidth]="compact ? null : '140px'"
      data-testid="garage-roster-details"
    >
      <soft-ds-select-option value="compact" label="Kompakt" />
      <soft-ds-select-option value="all" label="Alle" />
    </soft-ds-select>
  </div>
</ng-template>

<ng-template #selectionLeadingMenuBar>
  @let compact = hostComponent.compactMenuBar();
  <div class="flex items-center gap-2 h-full">
    @if (selectedEvents().length === 1) {
      <soft-ds-button
        variant="primary"
        size="md"
        [mode]="compact ? 'iconOnly' : 'default'"
        [title]="compact ? 'Editieren' : ''"
        (click)="service.handleContextMenuAction('edit')"
        data-testid="garage-roster-selection-edit"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-pencil" />
        </ng-template>
        Editieren
      </soft-ds-button>
    }

    @if (isOrderSelection()) {
      <soft-ds-button
        variant="outline"
        size="md"
        [mode]="compact ? 'iconOnly' : 'default'"
        [title]="compact ? 'SMS senden' : ''"
        (click)="service.handleContextMenuAction('sms')"
        data-testid="garage-roster-selection-sms"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-message-sms" />
        </ng-template>
        SMS senden
      </soft-ds-button>
    }

    @if (isAppointment() || isTaskSelection()) {
      <soft-ds-button
        variant="outline"
        size="md"
        [mode]="compact ? 'iconOnly' : 'default'"
        [title]="compact ? 'Duplizieren' : ''"
        (click)="service.handleContextMenuAction('duplicate')"
        data-testid="garage-roster-selection-duplicate"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-clone" />
        </ng-template>
        Duplizieren
      </soft-ds-button>
      <soft-ds-button
        variant="outline"
        size="md"
        [mode]="compact ? 'iconOnly' : 'default'"
        [title]="compact ? 'Kopieren' : ''"
        (click)="service.handleContextMenuAction('copy')"
        data-testid="garage-roster-selection-copy"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-copy" />
        </ng-template>
        Kopieren
      </soft-ds-button>
    }

    @if (selectedEvents().length > 0) {
      <soft-ds-button
        variant="destructive"
        size="md"
        [mode]="compact ? 'iconOnly' : 'default'"
        [title]="compact ? 'Löschen' : ''"
        (click)="service.handleContextMenuAction('delete')"
        data-testid="garage-roster-selection-delete"
      >
        <ng-template softSlot="leading">
          <soft-ds-icon name="fa-regular fa-trash-can" />
        </ng-template>
        Löschen
      </soft-ds-button>
    }
  </div>
</ng-template>

<ng-template #garageEventMenu>
  <soft-ds-context-menu>
    @if (selectedEvents().length === 1) {
      <soft-ds-context-menu-item
        icon="fa-regular fa-pen"
        label="Editieren"
        (triggered)="service.handleContextMenuAction('edit')"
      />
    }
    @if (isOrderSelection()) {
      <soft-ds-context-menu-item
        icon="fa-regular fa-message-sms"
        label="SMS senden"
        (triggered)="service.handleContextMenuAction('sms')"
      />
    }
    <soft-ds-context-menu-item
      icon="fa-regular fa-clone"
      label="Duplizieren"
      (triggered)="service.handleContextMenuAction('duplicate')"
    />
    <soft-ds-context-menu-item
      icon="fa-regular fa-copy"
      label="Kopieren"
      [keyboardShortcut]="[modifierKey, 'C']"
      (triggered)="service.handleContextMenuAction('copy')"
    />
    <soft-ds-context-menu-item
      icon="fa-regular fa-arrow-right"
      label="Auf nä. Montag kopieren"
      (triggered)="service.handleContextMenuAction('copyToNextMonday')"
    />
    <soft-ds-context-menu-divider />
    <soft-ds-context-menu-item
      icon="fa-regular fa-trash-can"
      label="Löschen"
      variant="danger"
      (triggered)="service.handleContextMenuAction('delete')"
    />
  </soft-ds-context-menu>
</ng-template>

<ng-template #selectionTrailingMenuBar>
  <span class="text-xs text-foreground/70 px-1">
    <span class="font-semibold">{{ selectedEvents().length }}</span>
    ausgewählt
  </span>
</ng-template>
